import { render, staticRenderFns } from "./thumb-bar.vue?vue&type=template&id=3f10e0c2&scoped=true"
import script from "./thumb-bar.vue?vue&type=script&lang=js"
export * from "./thumb-bar.vue?vue&type=script&lang=js"
import style0 from "./thumb-bar.vue?vue&type=style&index=0&id=3f10e0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10e0c2",
  null
  
)

export default component.exports